import type { ComponentPropsWithAs } from '@/@types/common'
import { css } from '@emotion/react'
import type { AnchorHTMLAttributes, ElementType } from 'react'

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {}

export default function Link<As extends ElementType = 'a'>({
	as: As,
	...props
}: ComponentPropsWithAs<LinkProps, As>) {
	const Component = As ?? ('a' as ElementType)
	return (
		<Component
			{...props}
			rel="noopener noreferrer"
			css={css`
				color: var(--tint-jike-blue);
				text-decoration: none;
				position: relative;

				&::after {
					content: '';
					position: absolute;
					left: 0;
					bottom: 0;
					z-index: 0;
					height: 1.5px;
					width: 100%;
					background-color: var(--tint-jike-blue);
					transform: scaleX(0);
					transform-origin: left;
					transition: transform 0.2s ease-out;
				}

				&:hover {
					&::after {
						transform: scaleX(1);
					}
				}
			`}
		/>
	)
}
